module.exports = __webpack_public_path__ + "static/img/download_icon.22422d2b.svg";